export const TIMEOUT = 10 * 6 * 1000

/*
  * data structure: {
  *   "first_name": String,
  *   "last_name": String,
  *   "apple_token": String,
  *   "nonce": String,
  *   "identity_token": String
  * }
  */

export default function () {
  return this.sendEventWithCallback('oauth.apple', {}, TIMEOUT)
    .then(data => {
      if (data.apple_token) {
        return data
      }

      return Promise.reject(
        new Error(this.ERROR_UNKNOWN)
      )
    })
}
